/* eslint-disable prefer-destructuring */

const US = 'US';
const CANADA = 'Canada';
const US_AND_CANADA = 'US & Canada';
const VALID_REGIONS = [US, CANADA, US_AND_CANADA];

const getDate = () => {
  const date = new Date();
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short'
  });
  const [{ value: month }, , { value: year }] = dateTimeFormat.formatToParts(lastDay);

  return `${month} ${year}`;
};

const removeCentsAddCommas = arg => {
  return Number(parseFloat(arg).toFixed(0)).toLocaleString('en', {
    minimumFractionDigits: 0
  });
};

const firstDate = firstRequested => {
  return firstRequested || 'Jul 2019';
};

const lastDate = lastRequested => {
  return lastRequested || getDate();
};

const digitFormatter = num => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return num.toFixed(0);
};

const createChartData = (elem, region) => {
  const regionLowerCase = () => {
    if (region === US) {
      return region.toLowerCase();
    }
    if (region === US_AND_CANADA) {
      return 'all';
    }
    return region.charAt(0).toLowerCase() + region.slice(1);
  };

  const { month, line_data: rawLineData, bar_data: barData } = elem;
  const lineData = rawLineData[regionLowerCase(region)];

  return {
    month,
    lineData,
    lineDataLabel: `$${digitFormatter(lineData)}`,
    barData
  };
};

function percIncrease(pub, benchmark) {
  if (!pub && !benchmark) {
    return 0;
  }

  const percent = (100 * (pub - benchmark)) / benchmark;
  return Math.floor(percent);
}

const generateLink = (queryParams, route) => {
  const searchParams = new URLSearchParams(queryParams);
  return `${window.origin}/${route}${searchParams.toString()}`;
};

const validateStoredRegion = storedRegion => {
  if (!VALID_REGIONS.includes(storedRegion)) {
    localStorage.setItem('contentValueRegion', US_AND_CANADA);
  }
};

const addTooltipToMonthlyData = (monthlyData, toolTipData) =>
  monthlyData.map((item, i) => Object.assign({}, item, toolTipData[i]));

export {
  removeCentsAddCommas,
  firstDate,
  lastDate,
  createChartData,
  percIncrease,
  generateLink,
  validateStoredRegion,
  addTooltipToMonthlyData,
  digitFormatter,
  US,
  CANADA,
  US_AND_CANADA,
  VALID_REGIONS
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/utils.js